import { FC, useMemo, useCallback } from 'react'
import { useStoreSelector, useStoreDispatch } from 'helpers/reactReduxHelpers'
import { AgoraUnPinVideoAction, AgoraPinVideoAction } from 'components/features/videoCalls/types/actions'
import { VideoFrameWrapper } from 'components/features/videoCallPanel/VideoFrameWrapper/VideoFrameWrapper'
import { mainStreamSelector } from 'components/features/videoCalls/selectors'
import { CallPanelPreset } from 'components/features/videoCallPanel/CallPanelPreset/CallPanelPreset'

type CallPanelProps = {
  isFullScreen: boolean
  onFullScreen: () => void
  onExitFullScreen: () => void
}
export const CallPanel: FC<CallPanelProps> = (props) => {
  const { onFullScreen, onExitFullScreen, isFullScreen } = props
  const mainStreamId = useStoreSelector(mainStreamSelector)
  const peers = useStoreSelector((state) => state.app.videoCall.peers.allKeys)
  const pinnedStreamId = useStoreSelector((state) => state.app.videoCall.details.pinnedStreamId)

  const dispatch = useStoreDispatch()

  const handleUnpin = useCallback(() => {
    if (!pinnedStreamId) {
      return
    }
    dispatch(new AgoraUnPinVideoAction())
  }, [dispatch, pinnedStreamId])

  const participantsChildren = useMemo(() => {
    return peers.map((peerId) => {

      if (peerId === mainStreamId) {
        return null
      }

      const handlePin = () => {
        dispatch(new AgoraPinVideoAction({ streamId: peerId }))
      }

      return (
        <VideoFrameWrapper
          key={ peerId }
          id={ peerId }
          isFullScreen={ isFullScreen }
          onPin={ handlePin }
          onUnpin={ handleUnpin }
          onFullScreen={ onFullScreen }
          onExitFullScreen={ onExitFullScreen }
        />
      )
    }).filter((item) => !!item)
  }, [dispatch, handleUnpin, isFullScreen, onExitFullScreen, onFullScreen, peers, mainStreamId])

  const mainFrameChild = useMemo(() => {
    if (!mainStreamId) {
      return null
    }

    return (
      <VideoFrameWrapper
        key={ mainStreamId }
        id={ mainStreamId }
        isFullScreen={ isFullScreen }
        isMainFrame
        isPinned={ !!pinnedStreamId }
        onUnpin={ handleUnpin }
        onFullScreen={ onFullScreen }
        onExitFullScreen={ onExitFullScreen }
      />
    )
  }, [handleUnpin, isFullScreen, mainStreamId, onExitFullScreen, onFullScreen, pinnedStreamId])

  return (
    <CallPanelPreset
      isFullScreen={ isFullScreen }
      mainFrame={ mainFrameChild }
      participants={ participantsChildren }
    />
  )
}
